import { render } from "./CustomFormSelect.vue?vue&type=template&id=1c76dabc"
import script from "./CustomFormSelect.vue?vue&type=script&lang=js"
export * from "./CustomFormSelect.vue?vue&type=script&lang=js"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__